<template>
  <div id="partnership">
    <div v-if="invalid_partnership">
      <error-component>
        <template slot="title">
          <h1>404 Error</h1>
        </template>
        <template slot="subtitle">
          <h2>Page not found</h2>
        </template>
        <template slot="message">
          <p>
            Missing a Partnership? Add a new Partnership by following the link below.
          </p>
        </template>
      </error-component>
    </div>
    <div v-if="!invalid_partnership">
      <div class="loading-screen" v-if="loading">
        <b-row>
          <b-col md="12">
            <h2>Loading...</h2>
          </b-col>
        </b-row>
      </div>
      <div :class="loading ? 'hidden' : 'content'">
        <maps
          :clickDisabled="true"
          :options="map_options">
            <template slot="title-rows">
              <b-row class="title-rows">
                <b-col>
                  <h1 id="explore-title">{{ partnershipTitle }}</h1>
                  <h2 class="partnership-states">
                    <span v-for="(stateProvince, index) in stateProvinces" :key="index">
                      {{ (index != (stateProvinces.length - 1)) ? stateProvince + ',' : stateProvince }}
                    </span>
                  </h2>
                </b-col>
              </b-row>
            </template>
        </maps>
        <br>
        <b-container>
          <b-row class="partnership-content">
            <b-col md="12">
              <h2>{{ partnership.name }}</h2>
              <b-row v-if="partnership.description">
                <b-col md="12">
                  <div>
                    <strong>Description</strong>
                    <p>
                      {{ partnership.description }}
                    </p>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="6">
                  <div>
                    <strong>Year Established</strong>
                    <p>
                      {{ partnership.year_established }}
                    </p>
                  </div>
                </b-col>
                <b-col md="6">
                  <div v-if="partnership.end_date">
                    <strong>Expected Tenure</strong>
                    <p>
                      {{ partnership.end_date }}
                    </p>
                  </div>
                </b-col>
              </b-row>
              <b-row v-if="partnership.grant_funding">
                <b-col md="12">
                  <strong>Funding Sources</strong>
                  <p>
                    {{ partnership.grant_funding }}
                  </p>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="6">
                  <strong>Sector</strong>
                  <p>
                    {{ partnership.sector }}
                  </p>
                </b-col>
                <b-col md="6">
                  <strong>Type</strong>
                  <p>
                    {{ partnership.type }}
                  </p>
                </b-col>
              </b-row>
              <b-row
                v-if="partnership.contact_name || partnership.email || partnership.contact_phone">
                  <b-col md="12">
                    <strong>Contact</strong>
                    <div class="contact-container" v-if="partnership.contact_name">
                      {{ partnership.contact_name }}
                    </div>
                    <div class="contact-container" v-if="partnership.email">
                      <a class="other" :href="'mailto:' + partnership.email">{{ partnership.email }}</a>
                    </div>
                    <div class="contact-container" v-if="partnership.contact_phone">
                      <a class="other" :href="'tel:' + partnership.contact_phone">{{ partnership.contact_phone }}</a>
                    </div>
                  </b-col>
              </b-row>
              <br v-if="partnership.institutions.length > 0">
              <div v-for="institution in partnership.institutions">
                <div>
                  <h2>{{ institution.name }}</h2>
                </div>
                <div
                  v-if="institution.contact_name || institution.contact_email || institution.contact_phone">
                    <strong>Contact</strong>
                    <div class="contact-container" v-if="institution.contact_name">
                      {{ institution.contact_name }}
                    </div>
                    <div class="contact-container" v-if="institution.contact_email">
                      <a class="other" :href="'mailto:' + institution.contact_email">{{ institution.contact_email }}</a>
                    </div>
                    <div class="contact-container" v-if="institution.contact_phone">
                      <a class="other" :href="'tel:' + institution.contact_phone">{{ institution.contact_phone }}</a>
                  </div>
                    <br>
                </div>
                <div v-if="institution.website">
                  <strong>Website</strong>
                  <br>
                  <a class="website" :href="institution.website" target="_blank">{{ institution.website }}</a>
                </div>
                <br>
              </div>
            </b-col>
          </b-row>
        </b-container>
      </div>
    </div>
  </div>
</template>

<script>
import ErrorComponent from '@/components/ErrorComponent'
import Maps from '@/components/Maps'

export default {
  name: 'Partnership',
  components: {
    ErrorComponent,
    Maps
  },
  computed: {
    partnershipTitle () {
      return this.partnership.name
    },
    stateProvinces () {
      return [...new Set(this.partnership.institutions.map(institution => {
        return institution.state_province
      }))].sort()
    }
  },
  data: () => ({
    partnership: {
      institutions: []
    },
    map_options: {},
    loading: true,
    invalid_partnership: false
  }),
  methods: {
    handleError (error) {
      /* eslint-disable no-self-assign */
      error = error
      return null
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.$root.setTitle('Partnership')

      vm.axios({
        method: 'get',
        url: '/program/' + to.params.partnership_slug
      }).then(response => {
        if (response.data.length !== 0) {
          if (response.data.name !== undefined) {
            vm.$root.setTitle(response.data.name + ' | Partnership')
          }

          vm.partnership = response.data

          vm.map_options = {
            state_provinces: response.data.state_provinces
          }
        } else {
          vm.invalid_partnership = true
        }

        vm.loading = false
      }).catch(error => {
        vm.handleError(error)
        vm.invalid_partnership = true
      })
    })
  }
}
</script>

<style lang="scss" scoped>
  hidden {
    visibility: hidden;
  }

  strong {
    color: grey;
    text-transform: capitalize;
  }

  p {
    font-weight: bold;
    font-style: italic;
  }

  div.contact-container {
    font-weight: bold;
    font-style: italic;
  }

  a.website {
    font-weight: bold;
    font-style: italic;
  }

  a.other {
    font-weight: bold;
    font-style: italic;
    color: #000000;
  }

  .partnership-header {
    height: 20rem;
    background-color: #000000;
    /**
     * Courtesy of StackOverflow User Carson
     * https://stackoverflow.com/a/4126253
     */
    margin: 0 -20px;
    padding: 2%;
    text-align: center;
  }

  .partnership-header > h1 {
    color: #ffffff;
    text-transform: capitalize;
  }

  .partnership-content {
    padding-top: 2%;
    padding-left: 12.5%;
    padding-right: 12.5%;
  }

  h2 {
    text-transform: capitalize;
    font-weight: 1000;
  }

  h2.partnership-states {
    color: #ffffff;
    text-transform: none;
    font-size: 1.35rem;
    font-weight: normal;
  }

  .map-container {
    max-width: 50%;
    max-height: 50%;
  }

  .loading-screen {
    position: relative;
    background-color: #000000;
    color: #ffffff;
    text-align: center;
    padding-top: 10%;
    padding-bottom: 15%;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Partnership.vue